import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  getWalletSummaryRequest,
  getWalletSummarySuccess,
  getWalletSummaryFailure,
} from '../../slices/wallet';
import { bookTripSuccess } from '../../slices/trip';

function* getWalletSummaryWorker() {
  try {
    const { isLoggedIn, travelAgency } = yield select((store) => store.user);

    if (!travelAgency) {
      return;
    }

    const doesAgencyUseWallets = !!travelAgency.enableCashPaymentForModes?.length;

    if (!isLoggedIn || !doesAgencyUseWallets) {
      yield put(getWalletSummarySuccess({ hasWallet: false }));
      return;
    }

    const config = {
      method: 'GET',
      url: 'wallet/summary',
    };

    const { data } = yield call(axios, config);

    yield put(getWalletSummarySuccess(data));
  } catch (error) {
    yield put(getWalletSummaryFailure({ error: `${error}` }));
  }
}

function* getWalletSummaryWatcher() {
  yield takeLatest(
    [getWalletSummaryRequest.toString(), bookTripSuccess.toString()],
    getWalletSummaryWorker,
  );
}

export default getWalletSummaryWatcher;
